module.exports = __webpack_public_path__ + "static/media/2000w.9b73b34d.jpg";